import axios from 'axios'
import { AddressVerificationToken } from 'features/checkout/types'

export const getInformaticaAddressToken = async (): Promise<AddressVerificationToken> => {
  const response = await axios.get('https://sit-api.hm.com/v1/token-mgmt-svc/token')
  return response.data
}
